var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    'lbz-state',
    _vm.type && ("lbz-state--" + _vm.type),
    _vm.background && ("lbz-state--bg-" + _vm.background),
    _vm.darkened && 'lbz-is-darkened',
    _vm.cisRipple && 'lbz-ripple',
    _vm.cisRipple && _vm.unbounded && 'lbz-is-unbounded'
  ],on:{"&touchstart":function($event){return _vm.ftouchstart($event)},"&touchend":function($event){return _vm.ftouchend($event)},"&mousedown":function($event){return _vm.fmousedown($event)},"&mouseup":function($event){return _vm.fmouseup($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }